module.exports = __webpack_public_path__ + "static/teiji-4a8b412141b10ee63e49d3d0a588ac26.jpg";